import { ReactNode, Dispatch, SetStateAction } from "react";
import EmailPasswordLogin from "./EmailPassword";
import PhoneOTPLogin from "./PhoneOTP";

export interface LoginMethodProps {
  setLoading: Dispatch<SetStateAction<boolean>>;
}

export enum LoginMethod {
  EmailAndPassword = "emailPassword",
  PhoneOTP = "phoneOTP",
}
